import { render, staticRenderFns } from "./Judo.vue?vue&type=template&id=dc989022"
import script from "./Judo.vue?vue&type=script&lang=js"
export * from "./Judo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports